<template>
  <div class="page">
    <div class="d_c">
      <p>充值信息</p>
      <span class="rt-pos" @click="goBack()"></span>
    </div>
    <div class="d_nei">
      <p class="d_p">
        <span>业务号：</span><span class="p_c">{{ propsParams.msisdn }}</span>
      </p>
      <p>
        <span>ICCID：</span><span class="p_c">{{ propsParams.iccid }}</span>
      </p>
      <p>
        <span>套餐名：</span><span class="p_c">{{ propsParams.productName }}</span>
      </p>
      <p>
        <span>生效日期：</span><span class="p_c">{{ propsParams.entryTime }}</span>
      </p>
      <p>
        <span>有效期：</span><span class="p_c">{{ propsParams.validTime }}</span>
      </p>
      <p>
        <span>流量：</span><span class="p_c">{{ propsParams.totalFlow }}</span>
      </p>
      <p>
        <span>价格：</span><span class="p_c"> {{ '¥' + propsParams.price }}</span>
      </p>
      <div class="d_phone" v-if="propsParams.showPhone == '1' && !initPhone">
        <nut-textinput placeholder="请输入联系电话" v-model="propsParams.phone" type="tel" maxlength="11"/>
        <nut-textinput placeholder="请输入验证码" v-model="propsParams.code" type="tel" maxlength="4"/>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{ count }}s后可重发</span>
        </div>
      </div>
      <div class="wenxin">
        <div class="p1">套餐说明：</div>
        <div class="p2">{{ propsParams.description }}</div>
      </div>
    </div>
    <!-- <form name="form"></form>  -->
    <div class="footer">
      <nut-button @click="pay()">下一步</nut-button>
    </div>
  </div>
</template>
<script>
import {wx_preOrder_check, wx_productDetail} from "@/api/api.js"; //获取套餐列表
import {wx_sendOrderSms} from "@/api/api.js"; //发送验证码
export default {
  data() {
    return {
      propsParams: {},
      phone: "",
      code: "",
      iccid: this.$route.query.iccid,
      initPhone: true,
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack() {
      this.$router.go(-1);
    },
    // 获取验证码
    getCode() {
      let params = {
        phone: this.propsParams.phone
      }
      wx_sendOrderSms(params).then(res => {
        if (res.data.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
    // 获取确认信息
    getPackage() {
      this.$toast.loading('加载中...', {
        duration: 500,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate: true
      });
      let params = {
        id: this.$route.query.id || sessionStorage.getItem("id"),
        type: this.$route.query.type || sessionStorage.getItem("type"),
        iccid: this.$route.query.iccid || sessionStorage.getItem("iccid")
      }
      wx_productDetail(params).then(res => {
        if (res.data.code == 200) {
          this.propsParams = res.data.data;
          this.initPhone = this.propsParams.phone;
          this.propsParams.entryTime = "立即生效";
          this.propsParams.validTime = this.propsParams.validTime.substr(0, 10);
          if (this.propsParams.description) {
            this.propsParams.description = res.data.data.description.replace(/[\r\n]/g, '\n')
          }
        }
      })
    },
    // 充值
    pay() {
      if (this.propsParams.showPhone == '1' && this.propsParams.phone.length != 11) {
        this.$toast.warn('请输入正确联系方式');
      } else {
        let that = this;
        let params = {
          iccid: that.iccid,
          phone: that.propsParams.phone,
          verCode: that.propsParams.code,
          productId: this.$route.query.id || sessionStorage.getItem("id")
        }
        wx_preOrder_check(params).then(res => {
          if (res.data.code == 200) {
            that.$router.push({
              name: "orderConfirmH5Next",
              params: {
                userWx: res.data.data.userWx == "0" ? true : false,
                renewalDesc: res.data.data.renewalDesc,
                renewalFlag: res.data.data.renewalFlag,
                iccid: that.iccid,
                price: that.propsParams.price,
                productId: that.propsParams.productId,
                phone: that.propsParams.phone,
                verCode: that.propsParams.code,
                pid: sessionStorage.getItem("packageId") || this.$route.query.packageId,
                type: "MWEB",
                userId: sessionStorage.getItem("userId"),
                channel: localStorage.getItem("channel")
              }
            })
          } else {
            this.$toast.fail(res.data.message);
          }
        })
      }
    },
  },
  created() {

  },
  mounted() {
    window.document.title = "确认订单";
    this.getPackage();
  },
};
</script>
<style scoped lang="less">
.page {
  .d_c {
    width: 100%;
    height: 180px;
    background: #F94040;
    z-index: 1;
    position: relative;

    .rt-pos {
      position: absolute;
      left: 20px;
      top: 14px;
      width: 12px;
      height: 12px;
      border-top: 2px solid gainsboro;
      border-left: 2px solid gainsboro;
      transform: rotate(-45deg);
    }

    p {
      font-size: 22px;
      text-align: center;
      color: #fff;
      padding-top: 35px;
    }
  }

  .d_nei {
    width: 95%;
    background: #fff;
    margin: 0 auto;
    z-index: 22;
    position: relative;
    top: -100px;
    padding: 5px;

    p {
      font-size: 14px;
      padding: 10px;
      display: flex;
      justify-content: space-between;

      .p_c {
        color: #F94040;
      }
    }

    /deep/ .nut-checkbox {
      margin-right: 0 !important;
      position: relative;
      top: -2px;
      width: 35px;
      text-align: right;
    }
  }

  .d_phone {
    width: 85%;
    margin: 0 auto;
    position: relative;

    /deep/ .nut-textinput input {
      width: 100%;
      margin-top: 10px;
      border: 2px solid #F94040;
      color: #999;
      font-size: 14px;
    }
  }

  .input-code {
    position: absolute;
    right: 15px;
    top: 65%;
    height: 30px;

    .opt-a {
      display: block;
      width: 75px;
      height: 30px;
      line-height: 30px;
      background: #F94040;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }
  }

  .wenxin {
    margin-top: 25px;
    padding: 10px;

    .p1 {
      color: #F94040;
      font-size: 14px;
    }

    .p2 {
      margin-top: 5px;
      white-space: pre-wrap;
    }
  }

  .footer {
    background: #F8F8F8;
    padding: 15px 0;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 23;

    button {
      border-radius: 10px;
      width: 52%;
      font-size: 14px;
      height: 45px;
      line-height: 45px;
      border: 1px solid #F94040 !important;
    }
  }

  .telecom-logo {
    width: 25px;
    height: 25px;
  }

  .renewalClass {
    font-size: 12px;
    text-align: center;
  }

  /deep/ .nut-radio {
    margin-right: 0 !important;
    width: 35px;
    text-align: right;
  }

  /deep/ .nut-textinput-clear {
    display: none;
  }
}
</style>


